import { Card, CardContent, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { Tooltip, LoadingBar } from '~components';

import itemsIcon from '../../../../assets/icons/items-24-px@2x.webp';
import { useStyles } from '../../style';

interface ItemsProps {
	dashboardItemsOverview?: {
		data?: object;
		loading?: boolean;
		error?: object | string;
	};
}

const Items = (props: ItemsProps) => {
	const classes = useStyles();
	const { dashboardItemsOverview } = props;
	const { t } = useTranslation();

	const { data: dashboardItemsOverviewData, loading: dashboardItemsOverviewLoading } =
		dashboardItemsOverview;

	const handleItems = (val) => (val ? val : 0);

	return (
		<Card className={classes.card}>
			<CardContent
				sx={{
					padding: '24px 16px',
					display: 'flex',
					flexWrap: 'wrap',
					justifyContent: 'space-between',
				}}
			>
				<Box display='flex'>
					<Box className={classes.tooltipContainer}>
						<Tooltip
							title={
								<Box pl={2}>
									<Typography>{t('views.dashboard.items.tooltip.overview')}</Typography>

									<ul>
										<li>
											<Typography>{t('views.dashboard.items.tooltip.itemsInUse')}</Typography>
										</li>
										<li>
											<Typography>{t('views.dashboard.items.tooltip.serviceItems')}</Typography>
										</li>
										<li>
											<Typography>{t('views.dashboard.items.tooltip.categoriesInUse')}</Typography>
										</li>
										<li>
											<Typography>{t('views.dashboard.items.tooltip.sharedItems')}</Typography>
										</li>
									</ul>
								</Box>
							}
							placement='bottom'
						>
							<img alt={'items-icon'} src={itemsIcon} width='25' height='25' />
						</Tooltip>
					</Box>
					<Box display='flex' flexDirection='column'>
						{dashboardItemsOverviewLoading ?
							<LoadingBar />
						:	<Typography>{`${t('views.dashboard.label.itemsInUse')}: ${handleItems(dashboardItemsOverviewData?.itemsInUse)}/${handleItems(dashboardItemsOverviewData?.itemsTotal)}`}</Typography>
						}
						{dashboardItemsOverviewLoading ?
							<LoadingBar />
						:	<Typography>{`${t('views.dashboard.label.serviceItems')}: ${handleItems(dashboardItemsOverviewData?.serviceItems)}`}</Typography>
						}
					</Box>
				</Box>
				<Box display='flex' flexDirection='column' pl={7}>
					{dashboardItemsOverviewLoading ?
						<LoadingBar />
					:	<Typography>{`${t('ui.category.categories')}: ${handleItems(dashboardItemsOverviewData?.categoryInUse)}/${handleItems(dashboardItemsOverviewData?.categoryTotal)}`}</Typography>
					}
					{dashboardItemsOverviewLoading ?
						<LoadingBar />
					:	<Typography>{`${t('views.dashboard.label.sharedItems')}: ${handleItems(dashboardItemsOverviewData?.sharedItems)}`}</Typography>
					}
				</Box>
			</CardContent>
		</Card>
	);
};

const mapStateToProps = (state) => {
	return {
		dashboardItemsOverview: state.details.dashboardItemsOverview,
	};
};

export default connect(mapStateToProps, null)(Items);
